import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM, MEDIA_MIN_XS } from '_assets/css/breakpoints';

export const container = css`
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing6});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 56px;

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const formField = css`
  width: 100%;
  max-width: 360px;
  margin-bottom: var(${SpacingToken.Spacing3});
  ${MEDIA_MIN_XS} {
    width: 360px;
  }
`;

export const button = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing4});
  max-width: 360px;
`;
